export default class Bullet {
  constructor (title, description, titleAdd = '') {
    this.title = title
    this.titleAdd = titleAdd
    this.description = description
  }
}
